export function getClosestSamplesBillingDate(
    subscriptions: ({ renewalDate?: any } | undefined)[],
) {
    const [closest] = getDefinedRenewalDates(subscriptions).sort(
        (nextDataPlanA, nextDatePlanB) => {
            return nextDataPlanA.getTime() - nextDatePlanB.getTime();
        },
    );

    return closest;
}

function getDefinedRenewalDates(
    subscriptions: ({ renewalDate?: string } | undefined)[],
): Date[] {
    const subscriptionsWithRenewalDate = subscriptions
        .filter((s) => !!s?.renewalDate)
        .map((s) => s!.renewalDate!);

    return subscriptionsWithRenewalDate.map(
        (renewalDate) => new Date(renewalDate),
    );
}
